import { Box, Typography } from "@bca/ui-library";
import React from "react";
import { formatMoney } from "../formatMoney";
import { InvoiceBreakdown } from "../Interfaces/vehicle.type";

interface InvoiceTotalProps {
  invoiceData: InvoiceBreakdown;
}

const InvoiceTotal: React.FunctionComponent<InvoiceTotalProps> = ({
  invoiceData,
}) => (
  <Box display="flex" justifyContent="space-between">
    <Typography variant="h6" color="footer-blue" marginTop={4}>
      Total Due
    </Typography>
    <Typography color="footer-blue">
      {formatMoney(invoiceData.unpaidAmount, 2)}
    </Typography>
  </Box>
);

export default InvoiceTotal;
